import styled from 'styled-components';

export const ManualCommandFormContainer = styled.div`
  /* width: 550px; */
`;
